import { AfterViewInit, Component } from '@angular/core';
import { IdentificationStepsService } from '../../services/identification-steps.service';
import { MobileScrollToService } from '../../../shared/services/mobile-scroll-to.service';

@Component({
    selector: 'payment-identification-identification',
    templateUrl: './payment.identification.identification.component.html',
    styleUrls: ['../../payment.component.scss']
})
export class PaymentIdentificationIdentificationComponent
    implements AfterViewInit
{
    public email = '';
    public loading = false;
    public attempts = 0;

    constructor(
        protected identificationStepsService: IdentificationStepsService,
        private mobileScrollToService: MobileScrollToService
    ) { }

    /**
     * Load store configurations
     **/
    ngAfterViewInit() {
        this.mobileScrollToService.scrollTo('#scroll-to-identification');
    }

    /**
     * Try proceed to next step if email is valid. Verify if email exists
     **/
    public next(validEmail: boolean) {
        console.log('Next step' + this.email + ' ' + validEmail + ' ' + this.attempts);
        if (this.email === '') {
            const emailInput = document.getElementById('payment-identification-identification-email') as HTMLInputElement;
            if (emailInput && emailInput.value.trim() !== '') {
                this.email = emailInput.value.trim();
            }
        }
        this.attempts += 1;
        if (this.email !== '' && validEmail) {
            this.loading = true;
            this.identificationStepsService
                .verifyEmailExists(this.email)
                .subscribe(() => {
                    this.loading = false;
                }, () => {
                    this.loading = false;
                });
        }
    }
    /**
     * focus event at email input listener.
     * */
    public onFocusIndentificationEmail() {
        console.log('Focus email');
        this.attempts = 0;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src2032928750/src/src/app/payment/identification/identification/payment.identification.identification.component.ts